import { Vue, Component, Prop} from "vue-property-decorator";
import CollectionControl from "@/components/collection-control";
import XTable from "@/components/x-table";
import XTh from "@/components/x-table/x-th";
import {ellipsis, formatDate, lexLabel} from "@/lib/helpers";
import ActionTh from "@/components/x-table/action-th";
import ActionTd from "@/components/x-table/action-td";

import CavPocAccesPossible from "@/lib/models/cav-poc-acces-possible";
import PanelPocAccesPossibles from "./panel-access-possibles";
import { Getter } from 'vuex-class';

@Component
export default class ControlPocAccesPossibles extends Vue {

  @Getter getPositionableBeanCoord;

  @Prop({type: Array}) readonly collection!: CavPocAccesPossible[];

  getBeanCoordL93RoundedString(d: CavPocAccesPossible) {
    const beanCoord = this.getPositionableBeanCoord(d);
    if (beanCoord) {
      const beanL93 = beanCoord.asL93();
      if (beanL93.isInFrance) {
        return `${Math.round(Number(beanL93.x))} / ${Math.round(Number(beanL93.y))}`;
      }
    }
    return "";
  }

  render() {
    return <CollectionControl
      data={this.collection}
      clazz={PanelPocAccesPossibles}
      scopedSlots={{
        body: ({ data, onEdit, onDelete }) => (
          <XTable data={data}
            class="is-full-width is-bordered is-small"
            scopedSlots={{
              header: () => (
                <tr>
                  <XTh prop="quand">Date</XTh>
                  <XTh prop="nom">Nom</XTh>
                  <XTh prop="lexPocTypeAcces">Type d'accès</XTh>
                  <XTh>X / Y (L93)</XTh>
                  <XTh prop="lexPocModaliteAcces" lblFn={lexLabel}>Modalité d'accès</XTh>
                  <XTh prop="lexPocEtatAcces" lblFn={lexLabel}>Etat de l'accès</XTh>
                  <XTh prop="domainePublicPrive" lblFn={lexLabel}>Dom.</XTh>
                  <XTh prop="commentaire">Commentaire</XTh>
                  <ActionTh/>
                </tr>
              ),
              row: ({d}: {d: CavPocAccesPossible}) => (
                <tr>
                  <td>{formatDate(d.quand)}</td>
                  <td>{d.nom}</td>
                  <td>{lexLabel(d.lexPocTypeAcces)}</td>
                  <td>{this.getBeanCoordL93RoundedString(d)}</td>
                  <td>{lexLabel(d.lexPocModaliteAcces)}</td>
                  <td>{lexLabel(d.lexPocEtatAcces)}</td>
                  <td>{d.domainePublicPrive}</td>
                  <td>{ellipsis(d.commentaire, 100)}</td>
                  <ActionTd
                    onEdit={() => onEdit(d)}
                    onDelete={() => onDelete(d)}
                  />
                </tr>
              )
            }}>
          </XTable>
        )
      }}>
    </CollectionControl>;
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-29bb59d6/control-access-possibles.tsx" });